export const SEND_EMAIL_NOTIF_REQUEST = "SEND_EMAIL_NOTIF_REQUEST";
export const SEND_EMAIL_NOTIF_SUCCESS = "SEND_EMAIL_NOTIF_SUCCESS";
export const SEND_EMAIL_NOTIF_FAILURE = "SEND_EMAIL_NOTIF_FAILURE";